import React, { SVGProps } from 'react';

export default function FastRewindIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="40"
      height="25"
      viewBox="0 0 40 25"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M32.8894 22.9656L32.8705 22.9548L21.0961 16.0974V20.2714C21.0961 21.133 20.8419 21.9566 20.2546 22.5754C19.6661 23.1955 18.887 23.4567 18.144 23.4567C17.5026 23.4567 16.8938 23.2686 16.3557 22.9656L16.3367 22.9548L3.52014 15.4904L3.51873 15.4896C3.01903 15.1978 2.51244 14.8564 2.13627 14.4039C1.70248 13.8821 1.50005 13.2867 1.50005 12.6391C1.50005 11.9915 1.70248 11.3961 2.13626 10.8743C2.51244 10.4218 3.01903 10.0804 3.51873 9.78861L3.52014 9.78779L16.3367 2.32341L16.3557 2.31256C16.8938 2.00954 17.5027 1.82153 18.144 1.82153C18.887 1.82153 19.6661 2.08267 20.2546 2.7028C20.8419 3.32158 21.0961 4.14522 21.0961 5.00678V9.18081L32.8705 2.32341L32.8894 2.31256C33.4366 2.00444 34.0585 1.82153 34.6907 1.82153C35.4337 1.82153 36.2128 2.08266 36.8013 2.70279C37.3886 3.32156 37.6428 4.1452 37.6428 5.00678V20.2714C37.6428 21.133 37.3886 21.9566 36.8013 22.5754C36.2128 23.1955 35.4337 23.4567 34.6907 23.4567C34.0584 23.4567 33.4366 23.2737 32.8894 22.9656Z"
        fill="white"
        stroke="black"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  );
}
